var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDropdownArrow(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 10,
    viewBox: "0 0 14 10",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.539 0.5H12.2207C12.131 0.5 12.0467 0.543945 11.9939 0.616016L6.99998 7.49961L2.00603 0.616016C1.9533 0.543945 1.86892 0.5 1.77928 0.5H0.460916C0.346658 0.5 0.279861 0.630078 0.346658 0.723242L6.54471 9.26797C6.76971 9.57734 7.23025 9.57734 7.45349 9.26797L13.6515 0.723242C13.7201 0.630078 13.6533 0.5 13.539 0.5Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDropdownArrow);
export default __webpack_public_path__ + "static/media/dropdown-arrow.d867bf1f.svg";
export { ForwardRef as ReactComponent };